package org.vreo.devicehub.features.core.presentation

import org.vreo.devicehub.features.core.domain.DataError
import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.error_data_invalid_credentials
import devicehub.composeapp.generated.resources.error_data_local_disk_full
import devicehub.composeapp.generated.resources.error_data_local_formatting
import devicehub.composeapp.generated.resources.error_data_local_invalid_argument
import devicehub.composeapp.generated.resources.error_data_local_invalid_state
import devicehub.composeapp.generated.resources.error_data_local_not_found
import devicehub.composeapp.generated.resources.error_data_local_serialization
import devicehub.composeapp.generated.resources.error_data_no_internet
import devicehub.composeapp.generated.resources.error_data_not_found
import devicehub.composeapp.generated.resources.error_data_rate_limit_exceeded
import devicehub.composeapp.generated.resources.error_data_request_timeout
import devicehub.composeapp.generated.resources.error_data_serialization
import devicehub.composeapp.generated.resources.error_data_service_unavailable
import devicehub.composeapp.generated.resources.error_data_storage_full
import devicehub.composeapp.generated.resources.error_data_storage_not_reachable
import devicehub.composeapp.generated.resources.error_data_too_many_requests
import devicehub.composeapp.generated.resources.error_data_unknown
import devicehub.composeapp.generated.resources.error_data_user_already_exists
import devicehub.composeapp.generated.resources.error_data_user_locked

/**
 * Converts [DataError] to [UiText].
 */
fun DataError.toUiText(): UiText {
    val stringRes = when (this) {
        DataError.Local.DISK_FULL -> Res.string.error_data_local_disk_full
        DataError.Local.SERIALIZATION -> Res.string.error_data_local_serialization
        DataError.Local.FORMATTING -> Res.string.error_data_local_formatting
        DataError.Local.INVALID_ARGUMENT -> Res.string.error_data_local_invalid_argument
        DataError.Local.INVALID_STATE -> Res.string.error_data_local_invalid_state
        DataError.Local.NOT_FOUND -> Res.string.error_data_local_not_found
        DataError.Local.UNKNOWN -> Res.string.error_data_unknown

        DataError.Remote.REQUEST_TIMEOUT -> Res.string.error_data_request_timeout
        DataError.Remote.TOO_MANY_REQUESTS -> Res.string.error_data_too_many_requests
        DataError.Remote.NO_INTERNET -> Res.string.error_data_no_internet
        DataError.Remote.SERIALIZATION -> Res.string.error_data_serialization
        DataError.Remote.INVALID_ARGUMENT -> Res.string.error_data_local_invalid_argument
        DataError.Remote.INVALID_CREDENTIALS -> Res.string.error_data_invalid_credentials
        DataError.Remote.NOT_FOUND -> Res.string.error_data_not_found
        DataError.Remote.USER_ALREADY_EXISTS -> Res.string.error_data_user_already_exists
        DataError.Remote.STORAGE_FULL -> Res.string.error_data_storage_full
        DataError.Remote.STORAGE_NOT_REACHABLE -> Res.string.error_data_storage_not_reachable
        DataError.Remote.RATE_LIMIT_EXCEEDED -> Res.string.error_data_rate_limit_exceeded
        DataError.Remote.SERVICE_UNAVAILABLE -> Res.string.error_data_service_unavailable
        DataError.Remote.USER_LOCKED -> Res.string.error_data_user_locked
        DataError.Remote.UNKNOWN -> Res.string.error_data_unknown
    }
    return UiText.StringResourceId(stringRes)
}